import React from "react";
import Layout from "../Dashboard/Layout";
import AddProducts from "../Dashboard/AddProducts";

const Addproduct = () => {
  return (
    <Layout>
      <AddProducts />
    </Layout>
  );
};

export default Addproduct;
